module.exports = __webpack_public_path__ + "img/carrousel-captores-1.7020cf77.jpg";